export default "__VITE_ASSET__Bt8L2lTn__"